import navigate from '~/mixins/navigate'

export default {
  mixins: [navigate],

  props: {
    type: {
      type: String,
      default: 'primary',
      validator: (prop) => ['primary', 'secondary', 'tertiary'].includes(prop),
    },
  },

  computed: {
    typeClasses() {
      const spanishVariationTertiary =
        this.type === 'tertiary' && this.$i18n.locale === 'es'
          ? 'button--tertiary--es'
          : ''

      return `button--${this.type} ${spanishVariationTertiary}`
    },
  },
}
